import { render, staticRenderFns } from "./SelectDept.vue?vue&type=template&id=7a60e4d0&scoped=true&"
import script from "./SelectDept.vue?vue&type=script&lang=js&"
export * from "./SelectDept.vue?vue&type=script&lang=js&"
import style0 from "./SelectDept.vue?vue&type=style&index=0&id=7a60e4d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a60e4d0",
  null
  
)

export default component.exports